import { create } from 'zustand';

// Screens that run full-screen (the mock test, a public quiz while it is being
// taken) must not show the app's bottom navigation. They flip this flag while
// mounted and the layout drops the nav bar.
interface AppChromeState {
  hideBottomNav: boolean;
  setHideBottomNav: (hide: boolean) => void;
}

export const useAppChrome = create<AppChromeState>((set) => ({
  hideBottomNav: false,
  setHideBottomNav: (hide) => set({ hideBottomNav: hide }),
}));
